/**
 * px値から％値へ変換する
 * @param child 子要素のpx値
 * @param parent 親要素のpx値
 */
export const pixelToPercent = (child: number, parent: number) => {
  return (child / parent) * 100
}
